export const location = (data) => {
    if (data.URL !== '') window.location.href = data
}
